import { render } from "./FileUploaderModal.vue?vue&type=template&id=4afca422&scoped=true&lang=pug"
import script from "./FileUploaderModal.vue?vue&type=script&lang=js"
export * from "./FileUploaderModal.vue?vue&type=script&lang=js"

import "./FileUploaderModal.vue?vue&type=style&index=0&id=4afca422&scoped=true&lang=sass"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4afca422"]])

export default __exports__